import moment from 'moment'
import { getText } from '../lib/text'

const plan1Tasks = [
  { day: 1, type: "call", text: getText("plan1_task1"), } ,
  { day: 3, type: "call", text: getText("plan1_task2"), } ,
  { day: 5, type: "msg",  text: getText("plan1_task3"), } ,
  { day: 8, type: "msg",  text: getText("plan1_task4"), } ,
  { day: 11, type: "msg", text: getText("plan1_task5"), } ,
  { day: 14, type: "msg", text: getText("plan1_task6"), } ,
  { day: 18, type: "msg", text: getText("plan1_task7"), } ,
  { day: 22, type: "msg", text: getText("plan1_task8"), } ,
]

/**
 * 
 */

// TODO: otros días de fiesta
// El 6 de enero, 20 de marzo, 13 y 14 de abril, 1 y 2 (Día de Madrid) de mayo, 15 de agosto, 12 de octubre, 1 de noviembre, 6, 8 y 25 de diciembre. 
function isWorkday(x) {
  const m = moment(x)
  const w = m.day() 

  if (w == 0 || w == 6) return false
  
  return true
}

function makePlan1(tripId: string, startDate: Object, encargado: string) {
  const tasks = plan1Tasks.map(({ day, text, type, user }) => ({ 
    dueDate: moment(startDate).add(day, "days").format("YYYY/MM/DD"), 
    text, 
    type, 
    user: user || encargado, 
    trip: tripId,
    plan: "plan1"
  }))

  // We have to fix the dates, so that no task falls on a saturday or sunday
 
  let shift = 0
  for (let i = 0; i < tasks.length; ++i) {
    const t = tasks[i]

    // apply accumulated shift from other tasks 
    t.dueDate = moment(t.dueDate).add(shift, "days")
    
    // ensure this is not a work day
    while (!isWorkday(t.dueDate)) {
      t.dueDate = moment(t.dueDate).add(1, "days")
      shift += 1
    }

    t.dueDate = moment(t.dueDate).format("YYYY/MM/DD")
  }

  return tasks
}

const getPlansList = () => ({ 
  plan1: { 
    id: "plan1", 
    name: getText("Plan 1"), 
    make: makePlan1, 
    text: getText("Cómo convencer a un cliente de que acepte nuestra propuesta"), 
    length: plan1Tasks.length 
  }, 
  // planVacio: {
  //   id: "planVacio", 
  //   name: "Plan vacío", 
  //   make: () => ([]),
  //   text: "Plan sin tareas, sólo para probar", 
  //   length: 0
  // }
})

export default getPlansList
